import type { ContentObjectView, PollContentObjectDetail, PollContentObjectList } from 'models';
import { Col, Row } from 'ui';
import { ContentObjectFooter } from '../../content-object-footer';
import { ContentObjectHeader } from '../../content-object-header';
import { ContentObjectPreview } from '../../content-object-preview';
import { useCreateActions } from './hooks';
import { PollContentObjectBody } from './poll-content-object-body';

type P = {
  item: PollContentObjectDetail | PollContentObjectList;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const PollContentObject = ({ item, onShowComments, view }: P) => {
  const { actions, contexts, editModal } = useCreateActions({ item, view });

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader actions={actions} item={item} view={view} />
      </Col>

      <Col span={24}>
        <PollContentObjectBody item={item} view={view} />
      </Col>

      <Col span={24}>
        <ContentObjectFooter
          item={item}
          onShowComments={onShowComments}
          preview={<ContentObjectPreview item={item} view="other" />}
          view={view}
        />
      </Col>
      {contexts}
      {editModal}
    </Row>
  );
};

export default PollContentObject;
